module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_perform.js
// module id = ./node_modules/babel-runtime/node_modules/core-js/library/modules/_perform.js
// module chunks = 0